import {
  configureStore,
  getDefaultMiddleware,
  ThunkAction,
  Action,
} from "@reduxjs/toolkit";
import { createBrowserHistory } from "history";
import { createReduxHistoryContext } from "redux-first-history";
import {
  persistStore,
  persistReducer,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import createRootReducer from "./rootReducer";

/**
 * Browser history context used for routing
 */
const {
  createReduxHistory,
  routerMiddleware,
  routerReducer,
} = createReduxHistoryContext({
  /** Browser History */
  history: createBrowserHistory(),

  /** Reducer key */
  routerReducerKey: "router",

  /** Save upto n previous locations (usefull for redirecetion after login) */
  savePreviousLocations: 3,

  // ... other options if needed
});

/**
 * Redux-persist configuration
 */
const persistConfig = {
  key: "root",
  version: 1,

  /** This could be any storage : AsyncStorage, WebStorage, etc... */
  storage,

  /** Reducers that to be persisted in storage */
  whitelist: ["login", "language"],

  /** Reducers that should not be persisted */
  blacklist: ["router"],
};

/**
 * Redux-toolkit middlewares array
 */
const middleware = [
  /** Default middle ware with serializable-check to support redux-persist */
  ...getDefaultMiddleware({
    serializableCheck: false,
  }),

  /** Router middleware */
  routerMiddleware,
];

/**
 * Persists the combined reduxers using provided persist configuration
 */
const persistedReducer = persistReducer(
  persistConfig,
  createRootReducer(routerReducer)
);

const store = configureStore({
  /** Combined reducers or reducers object */
  reducer: persistedReducer,

  /** Middlewares object*/
  middleware,
  devTools: true,
});

let persistor = persistStore(store);
const history = createReduxHistory(store);

export { history, store, persistor };

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
